import React, { lazy } from 'react';
const LearnToDriveWithUs = () => {
  return <section className="py-12 bg-white" data-id="element-213" data-mp="ed17y4selom6">
      <div className="container mx-auto px-4" data-id="element-214" data-mp="3un43sk0rir36">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-215" data-mp="3ulsuk4ojsr4o">
          Learn To Drive With Us
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-216" data-mp="3fhtw9ng9sdv">
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-217" data-mp="8fnqm48ku52t">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7mwVa6bd4whWYLDnonxPhc/learner_driver.png" alt="Automatic Driving Lessons Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-218" data-mp="36zdv8li983jq" />
            <div className="p-4" data-id="element-219" data-mp="3ln7bm8f5za3d">
              <p className="text-gray-700" data-id="element-220" data-mp="3loa2whgefejt">
                Modern automatic vehicles with dual controls and L plates for
                learner safety
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-221" data-mp="2t4tpv773rekn">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6C9xyeasQSxYB3YLkQ23gw/Trsuted_driver.png" alt="Driving Instructor Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-222" data-mp="2i0oglsbmerj7" />
            <div className="p-4" data-id="element-223" data-mp="23dmyxp3ltyu2">
              <p className="text-gray-700" data-id="element-224" data-mp="23ck7ng2ddudm">
                Professional instruction in a comfortable, relaxed learning
                environment
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-225" data-mp="1ublxsh592sn4">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wUvF8AjcNPDv3veNxhm1d5/instructor.png" alt="10-hour driving lessons Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-226" data-mp="1pciwn7se56kf" />
            <div className="p-4" data-id="element-227" data-mp="3es8sa0s5ihb9">
              <p className="text-gray-700" data-id="element-228" data-mp="3etbmoioon1vx">
                Build confidence with each lesson as you progress toward test
                readiness
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-229" data-mp="1huuqrto6g15d">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3xhxZjwjUY4ZL4apAphEPi/patient_instructor.png" alt="Patient driving instructor Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-230" data-mp="135f3worrofuy" />
            <div className="p-4" data-id="element-231" data-mp="20snhlxlj0kme">
              <p className="text-gray-700" data-id="element-232" data-mp="20rm7bvcc425q">
                Expert guidance from patient instructors who understand your
                learning needs
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-8" data-id="element-233" data-mp="1qt6dhklxaesj">
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your driving lessons in Northampton today" data-id="element-234" data-mp="bdqt46on01e8">
            Book Now
          </a>
        </div>
      </div>
    </section>;
};
export default LearnToDriveWithUs;